module.exports = __webpack_public_path__ + "img/mood.6ac4e45d.jpg";